import type { ReactNode } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import type { Scope } from "@busright/data-contract";

import { ScopedEntityPage } from "@/components/ScopedEntityPage";
import { FLEET_SCOPE } from "@/lib/scope";

// Recipient 360 — a thin wrapper over `ScopedEntityPage`, resolving the route's `:id` (+ optional
// `?level=` hint, mirroring the recipient bundle API) into a `Scope` and delegating everything else
// (identity header, health/telemetry/orders/inventory/RMA/support panels) to the shared template.
// Reachable from district/customer rows and from global search (a "recipient" hit lands here).
//
// The route only carries an id, not a human label — ScopedEntityPage/useRecipientBundle already
// degrade gracefully (falls back to `scopeDisplayName(scope)`) while the bundle loads, so no label
// is required up front.
export const RecipientPage = (): ReactNode => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const level = searchParams.get("level") === "account" ? "account" : "district";

  const scope: Scope = id ? { level, id, parent: FLEET_SCOPE } : FLEET_SCOPE;

  return <ScopedEntityPage scope={scope} />;
};
